import qs from 'query-string';

import type { Env } from './types';

export default function isDebugMode(environment: Env, queryString: string): boolean {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return Boolean(environment !== 'production' || qs.parse(queryString)['ub-debug']);
}
